var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"show-more"},[_c('span',{on:{"click":_vm.handleSecond}},[_vm._v(_vm._s(_vm.text.first.tips))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }